import { useBackendApi } from './backendApi';
import { LoadMoreResponse } from './Types';
import { useObjectDatesMapper } from './Helper';
import { SubscriptionEvent } from './webhookSubscriptionsService';

export interface WebhookRequestLogEntry {
  when: Date;
  teamId: number;
  subscriptionId: number;
  url: string;
  payload: {
    event: SubscriptionEvent;
    id: string;
  };
  result: string;
  serverResponse: {
    body?: string;
    headers?: Record<string, string[]>;
    status?: number;
  } | null;
}

export interface GetHistoryRequest {
  subscriptionId: number;
  limit?: number;
  fromTimestamp?: number;
}

export function useWebhookMonitoringService() {
  const nekstApi = useBackendApi();

  const objectMapper= useObjectDatesMapper<WebhookRequestLogEntry>([], ['when']);

  const getHistory = async (request: GetHistoryRequest): Promise<LoadMoreResponse<WebhookRequestLogEntry>> => {
    const params = new URLSearchParams();
    params.append('subscriptionId', request.subscriptionId.toString());

    if (request.limit) {
      params.append('limit', request.limit.toString());
    }

    if (request.fromTimestamp) {
      params.append('fromTimestamp', request.fromTimestamp.toString());
    }


    const response = await nekstApi.get(
      `/integrations/subscription/monitoring?${params.toString()}`
    );

    return {
      data: objectMapper.mapList(response.data),
      nextPageToken: response.nextPageToken,
    };
  };

  return {
    getHistory,
  };
}
